import { useNavigate } from "react-router-dom";
import { comicTags } from "@/mocks/comics";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[460px] w-full md:h-[600px]">
        <img
          src="https://readdy.ai/api/search-image?query=%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%E5%B1%B1%E6%B0%B4%E8%BF%9C%E6%99%AF%E5%B7%A8%E5%9E%8B%E7%A9%BA%E6%BB%91%E7%8E%87%EF%BC%8C%E5%B1%B1%E9%9B%BE%E7%BC%AD%E7%BB%95%E4%B8%8E%E8%B5%A4%E7%BA%A2%E5%A4%AA%E9%98%B3%E8%BE%89%E6%98%A0%EF%BC%8C%E8%80%81%E9%9B%80%E9%A3%9E%E8%BF%87%E5%B1%B1%E9%A1%B6%EF%BC%8C%E6%9A%97%E9%BB%91%E4%B8%8E%E7%87%8E%E7%81%AB%E7%BA%A2%E5%AF%B9%E6%AF%94%EF%BC%8C%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E5%86%99%E6%84%8F%E9%A3%8E%E6%A0%BC%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%BC%AB%E7%94%BB%E8%83%8C%E6%99%AF&width=1600&height=900&seq=hero-ink-2026&orientation=landscape"
          alt="古风漫画网水墨山水意境背景"
          title="古风漫画网 - 水墨山水背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>

        <div className="relative z-10 container-x flex h-full w-full flex-col items-center justify-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-background-50/10 px-4 py-1.5 text-sm font-semibold text-accent-200 backdrop-blur-sm">
            <i className="ri-sparkling-2-line text-accent-300"></i>
            古言 · 宫斗 · 权谋 · 武侠 · 仙侠 · 江湖
          </span>
          <h1 className="mt-5 font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            古风漫画网
          </h1>
          <p className="mt-3 max-w-2xl text-base font-medium text-background-200 md:text-lg">
            全题材古风国漫每日热更，分类清晰直达，追更收藏一步到位，为每一位古风漫画爱好者守护一方故事天地。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button onClick={() => navigate("/category")} className="btn-primary text-base">
              <i className="ri-play-circle-line mr-1.5"></i>立即开始阅读
            </button>
            <button
              onClick={() => navigate("/topics")}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-200 bg-background-50/10 px-6 py-3 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 cursor-pointer"
            >
              浏览题材专题
            </button>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {comicTags.map((tag) => (
              <button
                key={tag}
                onClick={() => navigate(`/category?tag=${encodeURIComponent(tag)}`)}
                className="rounded-full bg-background-50/10 px-3.5 py-1.5 text-sm text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}